<template>
  <offersList
    v-if="game"
    :key="'offers-list-' + game.id"
    ref="offersList"
    :offers="offers"
    :game="game"
    :offers-count="offersCount"
    :noitems-button-link="$i18n.path('profile/offers/new')"
    :categories="categories"
    :ads-list="adsList"
    path="games"
    :seo-title="seoTitle"
    :seo-description="seoDescription"/>
</template>

<script>
import { parseBool } from "~/services/booleanParser";
import { mapState, mapGetters } from "vuex";
import offersList from "~/components/offer/offersList/offersList.vue";
import axios from "axios";
import { findInTree } from "~/services/category";
import {
  getCategory,
  getOfferList,
  getCategoriesTree,
} from "~/services/offerList";
import slugify from "slugify";

export default {
  components: {
    offersList,
  },
  data() {
    return {
      swiperOption: {
        slidesPerView: "auto",
        spaceBetween: 0,
        freeMode: true,
        navigation: {
          nextEl: ".offers-category-next",
        },
      },
      updatingFilters: false,
      metaTitle: "",
      backendUrl: process.env.backendUrl,
      attributes: null,
      calculateAll: false,
    };
  },
  head() {
    return {
      title: this.seoTitle,
      meta: [
        {
          hid: `og:title`,
          name: "og:title",
          content: this.seoTitle,
        },
        {
          hid: `description`,
          name: "description",
          content: this.seoDescription,
        },
        {
          hid: `og:description`,
          name: "og:description",
          content: this.seoDescription,
        },
        {
          hid: `keywords`,
          name: "keywords",
          content: this.seoKeywords,
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      categoriesTree: "offerList/getCategoriesTree",
      calculateCategoryAttrs: "offerList/getCalculateCategoryAttrs",
      calculateCategoryOffers: "offerList/getCalculateCategoryOffers",
      calculateCategoryId: "offerList/getCalculateCategoryId",
      calculateCategoryName: "offerList/getCalculateCategoryName",
      adsList: "ads/getAdsList",
      offers: "offerList/getOffers",
      activeCategory: "offerList/getActiveCategory",
    }),
    ...mapState({
      user: (state) => state.auth.user,
      categories: (state) => state.offerList.categoriesTree.children,
    }),
    seoTitle() {
      if (this.activeCategory) {
        return this.activeCategory.seo
          ? this.activeCategory.seo.title
          : `Купить ${this.activeCategory.name} в игре ${this.game.name} | GoBuffy.com`;
      } else {
        return this.game.seo
          ? this.game.seo.title
          : `Все предложения в игре ${this.game.name} | GoBuffy.com`;
      }
    },
    seoDescription() {
      if (this.activeCategory) {
        return this.activeCategory.seo
          ? this.activeCategory.seo.description
          : `Покупайте ${this.activeCategory.name} в игре ${this.game.name} на GoBuffy.com. Система защиты покупателей GOBUFFY SHIELD, система споров, возврат средств, верификация продавцов и другие функции делают вашу покупку безопасной.`;
      } else {
        return this.game.seo
          ? this.game.seo.description
          : `Покупайте товары и услуги в игре ${this.game.name} на GoBuffy.com. Система защиты покупателей GOBUFFY SHIELD, система споров, возврат средств, верификация продавцов и другие функции делают вашу покупку безопасной.`;
      }
    },
    seoKeywords() {
      if (this.activeCategory) {
        return this.activeCategory.seo
          ? this.activeCategory.seo.keywords
          : `${this.game.name} ${this.activeCategory.name}`;
      } else {
        return this.game.seo
          ? this.game.seo.keywords
          : `${this.game.name} буст, аккаунты`;
      }
    },
  },
  watch: {
    $route() {
      Object.assign(this.$data, this.$options.data());
    },
    "$route.params.category": {
      handler: async function (category) {
        let categoryId = category
          ? category.substr(0, category.indexOf("-"))
          : undefined;
        this.$store.dispatch("ads/GET_ADS_LIST", {
          gameId: this.gameId,
          categoryId: categoryId ? categoryId : 0,
        });
      },
      deep: true,
      immediate: false,
    },
    "$route.query.page": {
      handler: function (page) {
        if (!page) {
          page = 1;
        }

        this.page = page;
        let filterGetOffers = this.activeCategory
          ? "category_id=" + this.activeCategory.id
          : "game_id=" + this.game.id;
        filterGetOffers += "&per-page=50" + (page ? "&page=" + page : "");
        filterGetOffers += "&status=3";
        if (this.updatingFilters) {
          this.updatingFilters = false;
          return;
        }

        let offersResponse;
        let offers;
        let offersCount;
        try {
          /*let loader = this.$loading
            ? this.$loading.show({
                canCancel: false,
              })
            : null;*/
          getOfferList(filterGetOffers, this.filtersRequestData).then(
            (offersResponse) => {
              /*if (loader) {
                loader.hide();
              }*/
              if (offersResponse) {
                this.$store
                  .dispatch("offerList/SET_OFFERS", offersResponse.offers)
                  .then(() => {
                    this.$forceUpdate();
                  });
              } else {
                this.$noty.error("Что-то пошло не так.");
              }
            }
          );
        } catch (exception) {
          this.$noty.error("Что-то пошло не так. " + exception);
          return exception;
        }
      },
      deep: false,
      immediate: false,
    },
  },
  async asyncData({ store, params, route, error, redirect }) {
    let showEmpty =
      store.state.auth.user != null && store.state.auth.user.role == 1;

    let gameId = params.game.substr(0, params.game.indexOf("-"));
    if (!gameId) {
      return error({ statusCode: 404 });
    }
    let categoryId = params.category
      ? params.category.substr(0, params.category.indexOf("-"))
      : undefined;

    /*****************************
     *
     * КИДАЕМ АСИНХРОННЫЕ ЗАПРОСЫ
     *
     *****************************/

    /** Запрос на оферы **/
    // Запрос на оферы - если у нас не переход на страницу с посчитанными оферами
    let filterGetOffers = categoryId
      ? "category_id=" + categoryId
      : "game_id=" + gameId;
    filterGetOffers +=
      (route.query.page ? "&page=" + route.query.page : "") + "&per-page=50";
    filterGetOffers += "&status=3";

    /** Запрос на игру **/

    /** Запрос на дерево категорий **/
    // Если нет дерева категорий в сторе то делаем запрос на получение категорий
    let categoriesRequest;
    let categories;
    if (
      !store.state.offerList.categoriesTree.children ||
      (store.state.offerList.categoriesTree &&
        store.state.offerList.categoriesTree.children &&
        store.state.offerList.categoriesTree.children[0].game_id != gameId)
    ) {
      let filter = "?gameId=" + gameId + "&showEmpty=" + showEmpty;
      categoriesRequest = getCategoriesTree(filter);
      try {
        let categoriesResponse = await categoriesRequest;
        store.dispatch(
          "offerList/SET_CATEGORIES_TREE",
          categoriesResponse.data
        );
        categories = categoriesResponse.data;
      } catch (error) {
        console.log(error);
      }
    }

    let filters = JSON.parse(JSON.stringify(route.query));

    let finalFilters = {};
    Object.keys(filters).forEach((item) => {
      if (item && typeof item == "string" && item.indexOf("filters") > -1) {
        let withoutPrefix = item.split("filters").join("");
        withoutPrefix = withoutPrefix.split("[").join("");
        withoutPrefix = withoutPrefix.split("]").join(" ");
        withoutPrefix = withoutPrefix.trim().split(" ");
        withoutPrefix.push(filters[item]);
        if (withoutPrefix.length == 4) {
          if (!finalFilters[withoutPrefix[0]]) {
            finalFilters[withoutPrefix[0]] = {};
          }
          if (!finalFilters[withoutPrefix[0]][withoutPrefix[1]]) {
            finalFilters[withoutPrefix[0]][withoutPrefix[1]] = {};
          }
          finalFilters[withoutPrefix[0]][withoutPrefix[1]][withoutPrefix[2]] =
            withoutPrefix[3];
        }
        if (withoutPrefix.length == 3) {
          if (!finalFilters[withoutPrefix[0]]) {
            finalFilters[withoutPrefix[0]] = {};
          }

          finalFilters[withoutPrefix[0]][withoutPrefix[1]] = withoutPrefix[2];
        }
      }
    });

    let activeCategory = null;
    if (categoryId) {
      activeCategory = findInTree(
        store.state.offerList.categoriesTree,
        "id",
        categoryId
      );

      store.dispatch("offerList/SET_ACTIVE_CATEGORY", activeCategory);

      /** Запрос на активную категорию **/
      try {
        let activeCategoryResponse = await getCategory(categoryId);
        if (activeCategoryResponse.success) {
          store.dispatch("offerList/SET_ACTIVECATEGORY_ATTRIBUTES", {
            id: activeCategory.id,
            attrs: activeCategoryResponse.data.attrs,
            seo: activeCategoryResponse.data.seo,
          });

          store.dispatch("offerList/SET_ACTIVECATEGORY_CALCULATE_ATTRIBUTES", {
            id: activeCategory.id,
            attrs: activeCategoryResponse.data.attrs.filter(function (attr) {
              return (
                attr.filled_by_buyer == 1 &&
                (attr.affects_time == 1 || attr.affects_price == 1)
              );
            }),
          });

          Object.keys(finalFilters).forEach(async (item) => {
            let zeroFilters = {
              nothing: false,
              rangeMultiple: {
                from: "",
                to: "",
              },
              text: null,
              rangeSingle: null,
              select: null,
              multiselect: {},
            };

            Object.keys(finalFilters[item]).forEach((fil) => {
              zeroFilters[fil] = finalFilters[item][fil];
            });
            store.dispatch("offerList/SET_ACTIVE_CATEGORY_ATTRIBUTE_FILTERS", {
              id: item,
              filters: zeroFilters,
            });
          });
        }
      } catch (error) {
        console.log(error);
      }

      /** Вдруг мы калькулировали уже эту категорию **/
      if (
        store.state.offerList.calculateCategoryId != null &&
        store.state.offerList.calculateCategoryId == categoryId
      ) {
        store.dispatch(
          "offerList/SET_OFFERS_ITEMS",
          store.state.offerList.calculateCategoryOffers
        );
        store.dispatch("offerList/SET_OFFERS_META", {});
      }
    } else {
      store.dispatch("offerList/SET_ACTIVE_CATEGORY", null);
    }

    let filtersRequestData = [];
    if (activeCategory && activeCategory.attrs) {
      filtersRequestData = store.state.offerList.activeCategory.attrs.filter(
        (item) => item.filters && item.filters.nothing == false
      );
    }

    let offersResponse;
    let offers;
    let offersCount;
    try {
      offersResponse = await getOfferList(filterGetOffers, filtersRequestData);
      store.dispatch("offerList/SET_OFFERS", offersResponse.offers);
    } catch (error) {
      console.log(error);
    }

    /** Обрабатываем запрос на игру **/
    let gameRequest = axios.get("/games/" + gameId + "?expand=parent,seo");
    let game = {};
    try {
      let gameResponse = await gameRequest;
      game = gameResponse.data.data;
      offersCount = gameResponse.data.data.offer_count;
    } catch (error) {
      console.log(error);
    }

    if (process.server) {
      let correctGamePath =
        game.id + "-" + slugify(game.name, { locale: "ru", lower: true });
      let correctCategoryPath = activeCategory
        ? activeCategory.id +
          "-" +
          slugify(activeCategory.name, { locale: "ru", lower: true })
        : "";
      if (
        correctGamePath != route.params.game ||
        (activeCategory && correctCategoryPath != route.params.category)
      ) {
        let path =
          "/games/" +
          correctGamePath +
          (activeCategory ? "/" + correctCategoryPath : "");

        return redirect(301, path);
      }
    }

    return {
      offersCount: offersCount,
      filtersRequestData: filtersRequestData,
      gameId: gameId,
      game: game,
    };
  },
  mounted() {
    if (!this.gameId) {
      return this.$nuxt.error({
        statusCode: 404,
        message: "Страница не найдена",
      });
    }
    this.$store.dispatch("ads/GET_ADS_LIST", {
      gameId: this.gameId,
      categoryId: this.activeCategory ? this.activeCategory.id : 0,
    });

    let _this = this;
    if (
      this.$refs["offersList"] &&
      this.$refs["offersList"].$refs["filters"] &&
      this.$refs["offersList"].$refs["filters"].$refs
    ) {
      Object.keys(this.$refs["offersList"].$refs["filters"].$refs).forEach(
        (item) => {
          if (_this.$refs["offersList"].$refs["filters"].$refs[item][0]) {
            if (_this.$refs["offersList"].$refs["filters"].$refs[item][0]) {
              _this.$refs["offersList"].$refs["filters"].$refs[
                item
              ][0].setActiveCategoryAttributeFilters();
            }
          }
        }
      );
    }

    this.$forceUpdate();
  },
  methods: {
    updateFilters() {
      if (!this.activeCategory || !this.activeCategory.attrs) {
        return null;
      }

      let filters = this.activeCategory.attrs.filter(
        (item) => item.filters && item.filters.nothing == false
      );

      let requestFilters = [];
      let attributesValues = {};

      filters.forEach((item) => {
        if (item.filters && !item.filters.nothing) {
          if (item.affects_price == 1 || item.affects_time == 1) {
            if (item.type == 0) {
              if (item.filters.yes === true) {
                attributesValues[item.id] = 1;
              } else {
                attributesValues[item.id] = 0;
              }
            }

            if (
              item.filters.rangeMultiple.from != undefined &&
              item.filters.rangeMultiple.to != undefined
            ) {
              let value = [
                parseInt(item.filters.rangeMultiple.from),
                parseInt(item.filters.rangeMultiple.to),
              ];
              attributesValues[item.id] = value;
            }

            if (item.filters.rangeSingle) {
              let value = [parseInt(item.filters.rangeSingle)];
              attributesValues[item.id] = value;
            }

            if (item.filters.text) {
              let value = [parseInt(item.filters.text)];
              if (value && value != NaN) {
                attributesValues[item.id] = value;
              }
            }

            if (Object.keys(item.filters.multiselect).length !== 0) {
              let multiSelectValues = [];
              Object.keys(item.filters.multiselect).forEach((key) => {
                if (parseBool(item.filters.multiselect[key]) == true) {
                  multiSelectValues.push(parseInt(key));
                }
              });
              attributesValues[item.id] = multiSelectValues;
            }

            if (item.filters.select) {
              let value = [parseInt(item.filters.select)];
              attributesValues[item.id] = value;
            }
          }

          let newAttr = {};
          Object.keys(item).forEach((obj) => {
            if (obj != "filters") {
              newAttr[obj] = item[obj];
            } else {
              newAttr.filters = {
                yes: item.filters.yes,
                no: item.filters.no,
                nothing: item.filters.nothing,
                rangeMultiple: {
                  from: item.filters.rangeMultiple
                    ? item.filters.rangeMultiple.from
                    : "",
                  to: item.filters.rangeMultiple
                    ? item.filters.rangeMultiple.to
                    : "",
                },
                text: item.filters.text,
                rangeSingle: item.filters.rangeSingle,
                select: item.filters.select,
                multiselect: item.filters.multiselect
                  ? item.filters.multiselect
                  : {},
                attributesValues: attributesValues,
              };
            }
          });

          requestFilters.push(newAttr);
        }
      });

      this.filtersRequestData = requestFilters;

      let browserString = {};

      this.filtersRequestData.forEach((item) => {
        if (item.type == 0) {
          browserString[item.id] = { yes: item.filters.yes };
        }
        if (item.type == 1 && item.view == null) {
          browserString[item.id] = { text: item.filters.text };
        }
        if (item.type == 1 && item.view == 2) {
          browserString[item.id] = { rangeSingle: item.filters.rangeSingle };
        }

        if ((item.type == 1 && item.view == 3) || item.type == 2) {
          browserString[item.id] = {
            rangeMultiple: item.filters.rangeMultiple,
          };
        }

        if ((item.type == 3 && item.view != 6) || item.type == 4) {
          browserString[item.id] = { multiselect: item.filters.multiselect };
        }

        if (item.type == 3 && item.view == 6) {
          browserString[item.id] = { select: item.filters.select };
        }
      });

      let serialize = function (obj, prefix) {
        var str = [],
          p;
        for (p in obj) {
          if (obj.hasOwnProperty(p)) {
            var k = prefix ? prefix + "[" + p + "]" : p,
              v = obj[p];
            str.push(
              v !== null && typeof v === "object"
                ? serialize(v, k)
                : encodeURIComponent(k) + "=" + encodeURIComponent(v)
            );
          }
        }
        return str.join("&");
      };

      let filtersString = serialize(browserString, "filters");

      history.pushState(
        {},
        null,
        this.$route.path +
          "?" +
          (!filtersString || filtersString != "" ? filtersString : "")
      );

      let filterGetOffers = this.activeCategory
        ? "category_id=" + this.activeCategory.id
        : "game_id=" + this.game.id;
      filterGetOffers +=
        "&per-page=50" + (this.page ? "&page=" + this.page : "");
      filterGetOffers += "&status=3";

      let offers;
      let offersCount;
      try {
        /*let loader = this.$loading
          ? this.$loading.show({
              canCancel: false,
            })
          : null;*/
        this.updatingFilters = true;
        getOfferList(filterGetOffers, this.filtersRequestData).then(
          (offersResponse) => {
            /*if (loader) {
              loader.hide();
            }*/
            if (offersResponse) {
              this.$store
                .dispatch("offerList/SET_OFFERS", offersResponse.offers)
                .then(() => {
                  let _this = this;
                  Object.keys(
                    this.$refs["offersList"].$refs["filters"].$refs
                  ).forEach((item) => {
                    if (
                      _this.$refs["offersList"].$refs["filters"].$refs[item][0]
                    ) {
                      _this.$refs["offersList"].$refs["filters"].$refs[
                        item
                      ][0].setActiveCategoryAttributeFilters();
                    }
                  });

                  this.$refs["offersList"].$refs["filters"].updateFiltersKey();
                  this.updatingFilters = false;
                  this.$forceUpdate();
                });
            } else {
              this.updatingFilters = false;
              this.$noty.error("Что-то пошло не так.");
            }
          }
        );
      } catch (exception) {
        this.updatingFilters = false;
        this.$noty.error("Что-то пошло не так. " + exception);
        return exception;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.offers-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 29px;
  padding-left: 16px;
  padding-right: 16px;
  padding-bottom: 20px;
  h1 {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin: 0;
    font-size: 20px;
    font-weight: 500;
    color: #2d303a;
    span {
      margin-left: 7px;
      display: inline-block;
      padding: 0 8px;
      font-size: 12px;
      line-height: 21px;
      color: #a8aaaf;
      background: #eff1f4;
      border-radius: 12px;
    }
  }
  img {
    margin-right: 13px;
  }
}

.offers-add {
  position: relative;
  width: 176px;
  height: 40px;
  line-height: 40px;
  font-size: 12px;
  font-weight: 500;
  background: $green;
  border-radius: 4px;
  text-align: center;
  color: #ffffff;
  padding-left: 40px;
  &:before {
    position: absolute;
    top: 50%;
    left: 25px;
    margin-top: -12px;
    content: "";
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background-image: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iMTAiIHZpZXdCb3g9IjAgMCAxMCAxMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEgNUg5TTUgMVY5IiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8L3N2Zz4K");
    background-color: rgba(#ffffff, 0.3);
    background-repeat: no-repeat;
    background-position: center;
  }
}

.offers-table {
  margin-top: -2px;
  border-top: 2px solid #eff1f4;
}

.offers-table-head {
  position: relative;
  padding-top: 5px;
  padding-bottom: 7px;
  background: #f7f9fc;
  font-size: 12px;
  font-weight: 500;
  text-transform: uppercase;
  .offers-table-col {
    color: #a8aaaf;
    span {
      position: relative;
      &:after {
        position: absolute;
        top: 50%;
        left: 100%;
        margin-top: -3px;
        margin-left: 5px;
        content: "";
        background: url("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTBweCIgaGVpZ2h0PSI3cHgiIHZpZXdCb3g9IjAgMCAxMCA3IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPCEtLSBHZW5lcmF0b3I6IFNrZXRjaCA1MS4yICg1NzUxOSkgLSBodHRwOi8vd3d3LmJvaGVtaWFuY29kaW5nLmNvbS9za2V0Y2ggLS0+CiAgICA8dGl0bGU+U2hhcGU8L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+CiAgICA8ZGVmcz48L2RlZnM+CiAgICA8ZyBpZD0iUGFnZS0xIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBpZD0iVmVjdG9yLTcuNCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMS4wMDAwMDAsIDEuMDAwMDAwKSIgZmlsbD0iI0E4QUFBRiIgZmlsbC1ydWxlPSJub256ZXJvIj4KICAgICAgICAgICAgPHBhdGggZD0iTTcuMjkyODkzMjIsLTAuNzA3MTA2NzgxIEM3LjY4MzQxNzUxLC0xLjA5NzYzMTA3IDguMzE2NTgyNDksLTEuMDk3NjMxMDcgOC43MDcxMDY3OCwtMC43MDcxMDY3ODEgQzkuMDk3NjMxMDcsLTAuMzE2NTgyNDg5IDkuMDk3NjMxMDcsMC4zMTY1ODI0ODkgOC43MDcxMDY3OCwwLjcwNzEwNjc4MSBMNCw1LjQxNDIxMzU2IEwtMC43MDcxMDY3ODEsMC43MDcxMDY3ODEgQy0xLjA5NzYzMTA3LDAuMzE2NTgyNDg5IC0xLjA5NzYzMTA3LC0wLjMxNjU4MjQ4OSAtMC43MDcxMDY3ODEsLTAuNzA3MTA2NzgxIEMtMC4zMTY1ODI0ODksLTEuMDk3NjMxMDcgMC4zMTY1ODI0ODksLTEuMDk3NjMxMDcgMC43MDcxMDY3ODEsLTAuNzA3MTA2NzgxIEw0LDIuNTg1Nzg2NDQgTDcuMjkyODkzMjIsLTAuNzA3MTA2NzgxIFoiIGlkPSJTaGFwZSI+PC9wYXRoPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+");
        width: 10px;
        height: 7px;
      }
    }
  }
  .offers-table-col-title {
    min-height: inherit;
  }
  .offers-table-col-time {
    padding-right: 40px;
  }
  .offers-table-col-price {
    padding-right: 20px;
  }
}
.offers-table-line {
  position: relative;
  font-size: 14px;
  color: #a8aaaf;
  border-bottom: 2px solid #eff1f4;
  transition: $link-transition;
  &:last-child {
    border-bottom: 0;
  }
  &:hover {
    background: rgba(#eff1f4, 0.3);
    .calculate-change {
      opacity: 1;
    }
  }
}
.offers-table-col {
  float: left;
  display: flex;
  height: 100%;
  flex-wrap: wrap;
  align-items: center;
}
.offers-table-col-user {
  position: absolute;
  top: 0;
  left: 0;
  width: 242px;
  height: 100%;
  padding-left: 16px;
  display: flex;
  align-items: center;
}
.offers-table-col-title {
  width: 100%;
  padding-left: 250px;
  padding-right: 360px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  padding-top: 10px;
  padding-bottom: 8px;
  min-height: 78px;
  color: #2d303a;
}
.offers-table-col-availability {
  position: absolute;
  top: 0;
  right: 230px;
  width: 130px;
  height: 100%;
  span:not(:first-child) {
    display: block;
    font-size: 12px;
    color: #a8aaaf;
  }
}
.availability-no {
  color: $red;
}
.offers-table-col-price {
  position: absolute;
  top: 0;
  right: 160px;
  width: 100px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  color: $body-color;
}

.offers-pagination {
  padding: 20px;
}

.offers-table-col-time {
  position: absolute;
  top: 0;
  right: 0;
  width: 160px;
  height: 100%;
  padding-right: 22px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  color: $body-color;
}
.table-rating {
  margin-right: 16px;
  display: flex;
  flex-direction: column;
}
.offers-table-img {
  position: relative;
  width: 32px;
  height: 32px;
  margin-right: 16px;
  img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
  }
}

.offers-category-main {
  margin-bottom: 0;
  padding: 0 16px;
  font-size: 14px;
  list-style: none;
  li {
    margin-right: 32px;
    display: inline-block;
    &:last-child {
      margin-right: 0;
    }
  }
}
.offers-category-link {
  position: relative;
  display: inline-block;
  padding: 10px 0;
  color: #a8aaaf;
  &:after {
    position: absolute;
    content: "";
    bottom: -2px;
    left: 0;
    right: 0;
    height: 2px;
    background: $blue;
    opacity: 0;
  }
  &.active {
    color: $blue;
    &:after {
      opacity: 1;
    }
  }
}
.offers-category {
  position: relative;
  min-height: 64px;
  //padding-right: 66px;
  //border-bottom: 2px solid #EFF1F4;
  border-top: 2px solid #eff1f4;
}
.offers-category-back {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  cursor: pointer;
  z-index: 10;
  width: 230px;
  padding-left: 70px;
  text-align: center;
  border-right: 2px solid #eff1f4;
  + .offers-category-wrapper {
    padding-left: 200px;
  }
}
.offers-category-wrapper {
  display: flex;
  flex-wrap: wrap;
}

.offers-category-back-link {
  position: absolute;
  display: block;
  top: 16px;
  left: 16px;
  width: 32px;
  height: 32px;
  border-radius: 4px;
  background-color: #eff1f4;
  background-repeat: no-repeat;
  background-position: center;
  cursor: pointer;
  background-image: url("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTJweCIgaGVpZ2h0PSI4cHgiIHZpZXdCb3g9IjAgMCAxMiA4IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPCEtLSBHZW5lcmF0b3I6IFNrZXRjaCA1MS4yICg1NzUxOSkgLSBodHRwOi8vd3d3LmJvaGVtaWFuY29kaW5nLmNvbS9za2V0Y2ggLS0+CiAgICA8dGl0bGU+U2hhcGU8L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+CiAgICA8ZGVmcz48L2RlZnM+CiAgICA8ZyBpZD0iUGFnZS0xIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBpZD0iVmVjdG9yLTkuMSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMS4wMDAwMDAsIDIuMDAwMDAwKSIgZmlsbD0iI0E4QUFBRiIgZmlsbC1ydWxlPSJub256ZXJvIj4KICAgICAgICAgICAgPHBvbHlnb24gaWQ9IlNoYXBlIiBwb2ludHM9IjUgMS40MTQyMTM1NiAwLjcwNzEwNjc4MSA1LjcwNzEwNjc4IC0wLjcwNzEwNjc4MSA0LjI5Mjg5MzIyIDUgLTEuNDE0MjEzNTYgMTAuNzA3MTA2OCA0LjI5Mjg5MzIyIDkuMjkyODkzMjIgNS43MDcxMDY3OCI+PC9wb2x5Z29uPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+");
}
.offers-category-slider {
  position: relative;
  width: 100%;
  &:after {
    position: absolute;
    content: "";
    top: 0;
    right: 0;
    width: 160px;
    height: 100%;
    background: linear-gradient(
      to left,
      #ffffff 20%,
      rgba(255, 255, 255, 0.001)
    );
    z-index: 2;
  }
}

.swiper-link {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 64px;
  padding-left: 10px;
  padding-right: 10px;
  text-align: center;
  font-size: 14px;
  width: 100%;
  color: #a8aaaf;
  overflow: hidden;
  cursor: pointer;
  &:before {
    position: absolute;
    content: "";
    bottom: 0;
    left: 0;
    right: 0;
    height: 2px;
    background: #098aff;
    transition: $link-transition;
    opacity: 0;
  }
  &:after {
    position: absolute;
    content: "";
    top: 0;
    bottom: 0;
    right: 0;
    width: 2px;
    background: #eff1f4;
  }
  &:hover {
    color: #6e7279;
    &:before {
      opacity: 0.3;
    }
  }
  &.active {
    color: $blue;
    &:before {
      opacity: 1;
    }
  }
}

.swiper-slide {
  max-width: 150px;
  width: 100%;
  &:last-child {
    .swiper-link {
      &:after {
        display: none;
      }
    }
  }
}
.offers-category-next {
  position: absolute;
  top: 50%;
  right: 16px;
  margin-top: -20px;
  width: 40px;
  height: 40px;
  background-color: #eff1f4;
  outline: 1px solid transparent;
  border-radius: 50%;
  background-position: center;
  background-repeat: no-repeat;
  cursor: pointer;
  background-image: url("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTBweCIgaGVpZ2h0PSIxNnB4IiB2aWV3Qm94PSIwIDAgMTAgMTYiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDUxLjIgKDU3NTE5KSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5TaGFwZTwvdGl0bGU+CiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4KICAgIDxkZWZzPjwvZGVmcz4KICAgIDxnIGlkPSJQYWdlLTEiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSJWZWN0b3ItNy4xIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxLjAwMDAwMCwgMS4wMDAwMDApIiBmaWxsPSIjNkU3Mjc5IiBmaWxsLXJ1bGU9Im5vbnplcm8iPgogICAgICAgICAgICA8cGF0aCBkPSJNLTAuMjA3MTA2NzgxLDEuNDU3MTA2NzggQy0wLjU5NzYzMTA3MywxLjA2NjU4MjQ5IC0wLjU5NzYzMTA3MywwLjQzMzQxNzUxMSAtMC4yMDcxMDY3ODEsMC4wNDI4OTMyMTg4IEMwLjE4MzQxNzUxMSwtMC4zNDc2MzEwNzMgMC44MTY1ODI0ODksLTAuMzQ3NjMxMDczIDEuMjA3MTA2NzgsMC4wNDI4OTMyMTg4IEw4LjE2NDIxMzU2LDcgTDEuMjA3MTA2NzgsMTMuOTU3MTA2OCBDMC44MTY1ODI0ODksMTQuMzQ3NjMxMSAwLjE4MzQxNzUxMSwxNC4zNDc2MzExIC0wLjIwNzEwNjc4MSwxMy45NTcxMDY4IEMtMC41OTc2MzEwNzMsMTMuNTY2NTgyNSAtMC41OTc2MzEwNzMsMTIuOTMzNDE3NSAtMC4yMDcxMDY3ODEsMTIuNTQyODkzMiBMNS4zMzU3ODY0NCw3IEwtMC4yMDcxMDY3ODEsMS40NTcxMDY3OCBaIiBpZD0iU2hhcGUiPjwvcGF0aD4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg==");
}

.swiper-slide-last {
  width: 80px;
  height: 17px;
  display: block;
}

.active-category {
  padding-left: 65px;
  line-height: 64px;
  color: #6e7279;
}

.calculate-block {
  min-height: 50px;
}
.swiper-container {
  width: 100%;
  padding-right: 66px;
}

.group-status {
  display: inline-block;
  vertical-align: middle;
  margin-right: 3px;
  margin-top: -2px;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: $grey-light;
  &.active {
    background: $green;
  }
}

.offer-category {
  display: block;
  a {
    color: $blue;
    font-size: 12px;
    cursor: pointer;
    transition: $link-transition;
    border-bottom: 1px solid transparent;
    &:hover {
      border-bottom: 1px solid rgba($blue, 0.7);
    }
  }
}
.offer-multiplier {
  display: block;
  font-size: 12px;
  color: #a8aaaf;
}

a.offer-category-name {
  color: $body-color;
}

.time-instantly {
  &:before {
    margin-right: 5px;
    display: inline-block;
    vertical-align: middle;
    width: 10px;
    height: 20px;
    content: "";
    background: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAxMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggb3BhY2l0eT0iMC43IiBkPSJNMCAwVjExSDNWMjBMMTAgOEg2TDEwIDBIMFoiIGZpbGw9IiNGRkIwMDAiLz4KPC9zdmc+Cg==");
  }
}

.offers-empty {
  padding-top: 52px;
  padding-bottom: 52px;
  text-align: center;
  border-top: 2px solid #eff1f4;
  color: #6e7279;
  h2 {
    margin-top: 30px;
    color: $body-color;
  }
}
.offers-empty-link {
  display: inline-block;
  padding-left: 35px;
  &:before {
    left: 12px;
  }
}
.empty-icon {
  display: inline-block;
  width: 84px;
  height: 83px;
  background: url("data:image/svg+xml;base64,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");
}

.page-description {
  margin-top: 64px;
  h1 {
    margin: 0;
    padding: 23px 16px;
    font-weight: 500;
    font-size: 20px;
    line-height: 24px;
    color: #2d303a;
    border-bottom: 2px solid #eff1f4;
  }
}
.page-description-text {
  padding: 17px 16px 5px;
}

.offers-category-active {
  padding-left: 80px;
}

.active-category-title {
  padding: 0 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 60px;
  line-height: 1.1;
}

.calc-warning {
  display: block;
  font-size: 12px;
  line-height: 14px;
  font-weight: 500;
  color: #6e7279;
  align-items: right;
}

.page-game-offers {
  display: flex;
  flex-direction: column-reverse;
}
</style>
